import { Phone, MessageCircle, Instagram, Facebook, Send } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/data";

const NAV_KEYS = ["about", "services", "why", "portfolio", "process", "contact"];

export const Footer = () => {
  const { t } = useLang();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-[#0B132B] border-t border-white/10 pt-20 sm:pt-28 pb-10" data-testid="site-footer">
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-10 w-10 rounded-lg bg-[#E85D04] text-white font-display font-extrabold text-xl">М</span>
              <span className="font-display font-extrabold text-2xl">Мастер на все руки</span>
            </div>
            <p className="text-[#9CA3AF] mt-5 max-w-sm leading-relaxed">{t.footer.desc}</p>
            <div className="flex gap-3 mt-6">
              {[Instagram, Facebook, Send].map((Icon, i) => (
                <span
                  key={i}
                  title={t.footer.soon}
                  className="grid place-items-center h-10 w-10 rounded-full border border-white/10 text-white/40 cursor-default"
                >
                  <Icon className="h-4 w-4" />
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-bold text-sm uppercase tracking-widest text-[#9CA3AF]">{t.footer.nav}</h4>
            <ul className="mt-5 space-y-3">
              {NAV_KEYS.map((k) => (
                <li key={k}>
                  <button
                    data-testid={`footer-nav-${k}`}
                    onClick={() => go(k)}
                    className="text-[#C7CCD6] hover:text-[#FF8C42] transition-colors"
                  >
                    {t.nav[k]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-bold text-sm uppercase tracking-widest text-[#9CA3AF]">{t.footer.contacts}</h4>
            <ul className="mt-5 space-y-3">
              {CONTACT.phones.map((p, i) => (
                <li key={i}>
                  <a href={`tel:${p.tel}`} className="flex items-center gap-3 text-[#C7CCD6] hover:text-[#FF8C42] transition-colors font-medium">
                    <Phone className="h-4 w-4 text-[#E85D04]" /> {p.display}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={`https://wa.me/${CONTACT.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[#C7CCD6] hover:text-[#25D366] transition-colors font-medium"
                >
                  <MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-sm text-[#6B7280] flex flex-col sm:flex-row justify-between gap-3">
          <span>© {new Date().getFullYear()} Мастер на все руки. {t.footer.rights}</span>
          <span>Repair · Renovation · Construction · Real Estate</span>
        </div>
      </div>
    </footer>
  );
};
